<template>
  <group-form :type="type" :group="newGroup"></group-form>
</template>

<script>
import GroupForm from '../Group/groupForm'
import {Group} from '../../../object'

export default {
  name: 'NewOrg',
  components: {GroupForm},
  data: () => ({
    newGroup: new Group(),
    type: Group.ORGANIZATION
  })
}
</script>

<style scoped>

</style>
